import { fitBounds } from '@components/Map/helper'
import { getUUIDv4 } from '@utils/helper'

export class ALayer {
  constructor(layer) {
    this.layer = Object.assign({ metadata: {} }, layer)
    this.layer.metadata = Object.assign({}, layer.metadata)
    this._id = this.layer.id || `${getUUIDv4()}`
    this.layer.id = this._id
    this.views = []
  }
  get layer_ids() {
    return [this.this.layer.id]
  }
  get id() {
    return this._id
  }
  get type() {
    return this.layer ? this.layer.type : ''
  }
  get data_type() {
    return this.layer ? this.layer.data_type : ''
  }
  get metadata() {
    return this.layer ? this.layer.metadata : {}
  }
  addToMap(map, beforeId) {
    if (this.beforeAddToMap) {
      this.beforeAddToMap(map, beforeId)
    }
    if (!map.getLayer(this.layer.id)) {
      map.addLayer(this.layer, beforeId)
    }
    this.withView((view) => {
      if (view.addToMap) {
        view.addToMap(this)
      }
    })
  }
  getBeforeId() {
    return this.id
  }

  removeFromMap(map) {
    if (map.getLayer(this.layer.id)) {
      map.removeLayer(this.layer.id)
    }
    if (map.getSource(this.layer.id)) {
      map.removeSource(this.layer.id)
    }
  }
  moveLayer(map, beforeId) {
    map.moveLayer(this.id, beforeId)
  }
  getStyle() {
    return this.layer
  }
  toggleShow(map, show) {
    map.setLayoutProperty(
      this.layer.id,
      'visibility',
      show ? 'visible' : 'none'
    )
  }
  setOpacity(map, opacity) {
    let keyOpacity =
      this.type == 'symbol' ? `icon-opacity` : `${this.type}-opacity`

    map.setPaintProperty(this.id, keyOpacity, opacity)
  }
  setStyle(map, style) {
    for (const key in style.paint) {
      map.setPaintProperty(this.layer.id, key, style.paint[key])
    }
    for (const key in style.layout) {
      map.setLayoutProperty(this.layer.id, key, style.layout[key])
    }
    this.withView((view) => {
      if (view.setStyle) {
        view.setStyle(style)
      }
    })
  }
  withView(cb) {
    for (let i = 0; i < this.views.length; i++) cb.bind(this)(this.views[i])
  }
  addView(layer_view) {
    this.views.push(layer_view)
  }
  flyTo(map) {
    let layer = this.layer
    if (!layer.metadata || !layer.metadata.bounds) {
      return
    }

    fitBounds(map.id, layer.metadata.bounds)
  }
}
